<!-- <div class="modal-header position-relative">
  <h4>{{ welcomeDialogData.header }}</h4>
  
</div> -->
<div class="position-relative">
  <div
    class="cursor-pointer close-dialog position-absolute"
    (click)="welcomeDialogRef.close()"
  >
    <img
      class="resp-image"
      src="https://media.umangapp.in/cdn/landing/close.svg"
      alt="close"
      width="12px"
      height="12px"
      loading="lazy"
      fetchpriority="high"
    />
  </div>
  <div class="modal-body">
    <div class="modal-body__image">
      <img
      *ngIf="welcomeDialogData.logo?.isActive"
      imgFallback
      [src]="welcomeDialogData.logo?.url"
      alt="img"
      class="brand-logo resp-image"
      width="100px"
      height="100px"
      loading="lazy"
      fetchpriority="high"
    />
    </div>
    <div class="dialog-content">
      <h4 [innerHtml]="welcomeDialogData.textHTML | safeHTML"></h4>
      <p [innerHTML]="welcomeDialogData.subTextHTML | safeHTML"></p>
    </div>
  </div>
  <div
    class="modal-footer"
    *ngIf="
      welcomeDialogData.action10?.isActive ||
      welcomeDialogData.action12?.isActive
    "
  >
    <ng-container *ngIf="welcomeDialogData.action10?.isActive">
      <a
        *ngIf="welcomeDialogData.action10?.external; else sameTabLink"
        class="btn btn-primary btn-sm"
        [href]="welcomeDialogData.action10?.externalUrl"
        target="_blank"
        (click)="logEvent(welcomeDialogData)"
        [title]="welcomeDialogData.action10?.tooltip"
        >{{ welcomeDialogData.action10?.value }}</a
      >
      <ng-template #sameTabLink>
        <button
          *ngIf="!welcomeDialogData.action10?.external"
          class="btn btn-primary btn-sm"
          [title]="welcomeDialogData.action10?.tooltip"
          (click)="openLinkSameTab(welcomeDialogData?.action10?.url)"
        >
          {{ welcomeDialogData.action10?.value }}
        </button>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="welcomeDialogData.action12?.isActive">
      <a
        *ngIf="welcomeDialogData.action12?.external; else sameTabLink"
        class="btn btn-primary btn-sm"
        [href]="welcomeDialogData.action12?.externalUrl"
        target="_blank"
        [title]="welcomeDialogData.action12?.tooltip"
        (click)="logEvent(welcomeDialogData)"
        >{{ welcomeDialogData.action12?.value }}</a
      >
      <ng-template #sameTabLink>
        <button
          *ngIf="!welcomeDialogData.action12?.external"
          class="btn btn-primary btn-sm"
          [title]="welcomeDialogData.action12?.tooltip"
          (click)="openLinkSameTab(welcomeDialogData?.action12?.url)"
        >
          {{ welcomeDialogData.action12?.value }}
        </button>
      </ng-template>
    </ng-container>
  </div>
</div>
